import React from 'react';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';
import Image from '../../../components/image';
import Label from '../../../components/label';
import styles from './view.scss';

function View(props) {
  const { t, i18n } = props;

  return (
    <div className={clsx('claim-expired-container', styles.container)}>
      <div className={clsx('claim-expired-background-image-container', styles.imageContainer)}>
        <Image
          alt=""
          src={
            i18n.exists('claim.expired.background_image.src')
              ? t('claim.expired.background_image.src')
              : ''
          }
          className={clsx('claim-expired-background-image', styles.image)}
        />
      </div>
      <div className={clsx('claim-expired-inner-container', styles.innerContainer)}>
        <Label
          className={clsx('claim-expired-text', styles.expiredText)}
          text={t('claim.expired.text')}
        />
        <div className={clsx('claim-expired-footer-space', styles.footerSpace)} />
        <Label
          className={clsx('claim-expired-footer', styles.footer)}
          text={t('claim.expired.footer')}
        />
      </div>
    </div>
  );
}

export default withTranslation()(View);
